export var AgreementProvider;
(function (AgreementProvider) {
    AgreementProvider["MONDOGATE"] = "MONDOGATE";
    AgreementProvider["BTCDIRECT"] = "BTCDIRECT";
    AgreementProvider["TANGANY"] = "TANGANY";
    AgreementProvider["PAYCENTER"] = "PAYCENTER";
})(AgreementProvider || (AgreementProvider = {}));
//# sourceMappingURL=agreement.types.js.map